import PropTypes from 'prop-types';
import React from 'react';
import Dialog from './dialog.jsx';

export default function Logout(props) {
    let title, content, msg, cnt;

    if (props.localContent.length > 0) {
        cnt = props.localContent.length;
        title = 'Are you sure?';
        msg = `You will lose access to the ${cnt} downloaded course material${
            cnt > 1 ? 's' : ''
        }`;
        content = (
            <div>
                <p>{msg}</p>
                <p>
                    To access Engage while offline, close this window and
                    Bookmark Engage.
                </p>
                <p>When offline, just click on the bookmark!</p>
            </div>
        );
    } else if (props.downloadingContent.length > 0) {
        cnt = props.downloadingContent.length;
        title = 'Cancel download?';
        msg = `You are currently downloading ${cnt} course material${
            cnt > 0 ? 's' : ''
        } for offline use.`;
        content = (
            <div>
                <p>{msg}</p>
                <p>Logging out will cancel all downloads in progress.</p>
            </div>
        );
    } else {
        props.logout();
        return <noscript />;
    }

    const buttons = [];

    buttons.push({
        label: 'Cancel',
        onClick: () => null,
        dismiss: true,
    });

    buttons.push({
        label: 'Log me out',
        onClick: props.logout,
        dismiss: false,
    });

    return (
        <Dialog
            buttons={buttons}
            closeButton
            className="alert"
            onClose={() => props.routeToTerm({ termId: props.termId })}
            title={title}
        >
            {content}
        </Dialog>
    );
}
Logout.propTypes = {
    logout: PropTypes.func.isRequired,
    localContent: PropTypes.array.isRequired,
    downloadingContent: PropTypes.array.isRequired,
    termId: PropTypes.number.isRequired,
    routeToTerm: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/logout.ui.jsx